<div
  #origin="cdkOverlayOrigin"
  cdkOverlayOrigin
  class="flex items-center justify-between gap-1"
>
  <ng-container [ngSwitch]="searchable && isOpen">
    <input
      #input
      (input)="onHandleInput($event)"
      *ngSwitchCase="true"
      class="flex-1 outline-none placeholder-line"
      placeholder="Start typing..."
    />
    <span
      *ngSwitchCase="false"
      class="flex-1"
    >
      <ng-container [ngSwitch]="!!value">
        <ng-container *ngSwitchCase="true">
          <ng-content select="[select-display]"></ng-content>
        </ng-container>

        <ng-container *ngSwitchCase="false">
          <span class="mat-select-placeholder">
            {{ placeholder || 'Nothing is selected...' }}
          </span>
        </ng-container>
      </ng-container>
    </span>
  </ng-container>

  <ng-container *ngIf="!disabled">
    <button
      (click)="clearSelection($event)"
      *ngIf="value && clearable"
      class="text-xs text-dark bg-transparent px-2 opacity-70 hover:opacity-100 hover:bg-line"
    >
      clear
    </button>

    <div class="mat-select-arrow-wrapper">
      <div class="mat-select-arrow"></div>
    </div>
  </ng-container>
</div>

<ng-template
  (backdropClick)="close()"
  (detach)="close()"
  [cdkConnectedOverlayOffsetX]="0"
  [cdkConnectedOverlayOffsetY]="0"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayPanelClass]="['my-4']"
  [cdkConnectedOverlayScrollStrategy]="scrollFactory"
  cdkConnectedOverlay
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  cdkConnectedOverlayHasBackdrop
  cdkConnectedOverlayTransformOriginOn="left"
>
  <div
    (@dropDown.done)="onPanelAnimationDone($event)"
    [@dropDown]
    class="mat-select-panel origin-top select-none !max-w-full"
  >
    <ng-content select="[select-options]"></ng-content>
  </div>
</ng-template>
